import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import  { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
    });
    // Also clear old caches created by the SW
    if (window.caches && caches.keys) {
        caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
    }
}




// WEBPACK FOOTER //
// ./src/index.js